<template>

    <renderReelFacebook
        v-if="typeNetworkSelected == 'facebook' && filesNetwork.length == 1 && filesNetwork[0].info.type2 == 'video'" 
        :medias="filesNetwork" 
        :pages="pagesEdited"
        @clickPage="clickPageInRenderPost" 
        :musicName="null" 
        :description="textContentConverted"
        :modes="modes" 
        :mentions = "mentions"
        :positionFormOverlay="positionFormOverlay"
        :place="place"
        :personsIdentified="personsIdentified"
        :collaborators="collaborators"
    />

    <renderPostFacebook 
        v-else-if="typeNetworkSelected == 'facebook'" 
        :medias="filesNetwork" 
        :pages="pagesEdited"
        @clickPage="clickPageInRenderPost" 
        :text="textContentConverted" 
        :comments="commentsConverted" 
        :datePost="datePost"
        :modes="modes"
        :snippet="snippet"
        :mentions = "mentions"
        :place="place"
        :positionFormOverlay="positionFormOverlay"
    />
    
    <renderReelInstagram 
        v-else-if="
            typeNetworkSelected == 'instagram' && 
            filesNetwork.length == 1 && 
            filesNetwork[0].info.type.startsWith('video/')
        "
        :medias="filesNetwork" 
        :pages="pagesEdited"
        @clickPage="clickPageInRenderPost" 
        :music="music"
        :description="textContentConverted"
        :modes="modes" 
        :mentions = "mentions"
        :positionFormOverlay="positionFormOverlay"
        :place="place"
        :personsIdentified="personsIdentified"
        :collaborators="collaborators"
        :products="products"
    />
    
    <renderPostInstagram 
        v-else-if="typeNetworkSelected == 'instagram'" 
        :medias="filesNetwork" 
        :pages="pagesEdited"
        @clickPage="clickPageInRenderPost" 
        :text="textContentConverted" 
        :comments="commentsConverted" 
        :datePost="datePost"
        :modes="modes" 
        :personsIdentified="personsIdentified"
        :collaborators="collaborators"
        :music="music"
        :place="place"
        :ratio="ratio"
        :mentions="mentions"
        :products="products"
        :positionFormOverlay="positionFormOverlay"
    />
    <renderPostLinkedin 
        v-else-if="typeNetworkSelected == 'linkedin'" 
        :medias="filesNetwork" 
        :survey="survey"
        :files="files"
        :pages="pagesEdited"
        @clickPage="clickPageInRenderPost" 
        :text="textContentConverted" 
        :comments="commentsConverted" 
        :datePost="datePost"
        :snippet="snippet" 
        :mentions = "mentions"
    />

    <renderPostThreads  
        v-else-if="typeNetworkSelected == 'threads'" 
        :medias="filesNetwork"
        :pages="pagesEdited"
        @clickPage="clickPageInRenderPost" 
        :text="textContentConverted" 
        :comments="commentsConverted" 
        :datePost="datePost"
        :snippet="snippet"
        :mentions="mentions"
    />

    <renderPostTwitter
        v-else-if="typeNetworkSelected == 'twitter'" 
        :medias="filesNetwork" 
        :pages="pagesEdited"
        @clickPage="clickPageInRenderPost" 
        :text="textContentConverted" 
        :comments="commentsConverted" 
        :datePost="datePost"
        :snippet="snippet"
        :mentions = "mentions"
        :verifiedMode = "pages.every(page => page.story_config && page.story_config.verified_type !== 'none')"
        :tweetSplitting="formData.formDataNetwork.twitter.tweetSplitting ? formData.formDataNetwork.twitter.tweetSplitting.active : false" 
    />

    <renderPostBluesky
        v-else-if="typeNetworkSelected == 'bluesky'" 
        :medias="filesNetwork" 
        :pages="pagesEdited"
        @clickPage="clickPageInRenderPost" 
        :text="textContentConverted" 
        :comments="commentsConverted" 
        :datePost="datePost"
        :snippet="snippet"
        :mentions = "mentions"
    />

    <renderPostTiktok
        v-else-if="typeNetworkSelected == 'tiktok'"
        :medias="filesNetwork"
        :pages="pagesEdited"
        @clickPage="clickPageInRenderPost"
        :title="textContentConverted ? Array.from(textContentConverted).slice(0, 90).join('').split(/<br\s*\/?>|<\/br>|\n/i)[0] : undefined"
        :text="textContentConverted ? Array.from(textContentConverted.split(/<br\s*\/?>|<\/br>|\n/i).slice(1).join('\n')).slice(0, 4000).join('') : undefined"
        :mentions="mentions"
        :modes="modes"
        :music="music"
        :positionFormOverlay="positionFormOverlay"
    />

    <renderPostGoogle v-else-if="typeNetworkSelected == 'google'" 
        :medias="filesNetwork" 
        :pages="pagesEdited"
        @clickPage="clickPageInRenderPost" 
        :text="textContentConverted" 
        :datePost="datePost"
        :snippet="snippet"
        :mentions = "mentions"
    />

    <renderPostTelegram 
        v-else-if="typeNetworkSelected == 'telegram'" 
        :medias="filesNetwork"  
        :pages="pagesEdited"
        @clickPage="clickPageInRenderPost" 
        :text="textContentConverted"
        :comments="commentsConverted" 
        :datePost="datePost"
        :snippet="snippet"
        :mentions = "mentions"
    />
  
    <renderPostPinterest 
        v-else-if="typeNetworkSelected == 'pinterest'" 
        :medias="filesNetwork" 
        :pages="pagesEdited"
        @clickPage="clickPageInRenderPost" 
        :title="textContentConverted ? Array.from(textContentConverted.split(/<br\s*\/?>|<\/br>|\n/i)[0]).slice(0, 100).join('') : undefined"
        :text="textContentConverted ? textContentConverted.split(/<br\s*\/?>|<\/br>|\n/i).slice(1).join('\n') : undefined"
        :datePost="datePost"
        :snippet="snippet"
        :mentions="mentions"
    />

    <renderShortYoutube 
        v-else-if="typeNetworkSelected == 'youtube' && (!filesNetwork.length || filesNetwork[0].info.aspectRatio == 0.5625)" 
        :medias="filesNetwork" 
        :pages="pagesEdited"
        @clickPage="clickPageInRenderPost" 
        :musicName="null" 
        :description="textContentConverted"
        :mentions = "mentions"
    />

    <renderPostYoutube 
        v-else-if="typeNetworkSelected == 'youtube'" 
        :medias="filesNetwork" 
        :pages="pagesEdited"
        @clickPage="clickPageInRenderPost" 
        :title="textContentConverted ? Array.from(textContentConverted).slice(0, 100).join('').split(/<br\s*\/?>|<\/br>|\n/i)[0] : undefined"
        :text="textContentConverted ? textContentConverted.split(/<br\s*\/?>|<\/br>|\n/i).slice(1).join('\n') : undefined"
        :comments="commentsConverted" 
        :datePost="datePost"
        :mentions = "mentions"
    />
</template>


<script>
    import { listNetworkSort } from './../../constante.js'
    import { 
        getFilesByNetwork,
        mergeUpdates
    } from './../../utils.js'

    import renderPostInstagram from "./renderPost/postInstagram.vue"
    import renderReelInstagram from "./renderPost/reelInstagram.vue"
    import renderPostFacebook from "./renderPost/postFacebook.vue"
    import renderReelFacebook from "./renderPost/reelFacebook.vue"
    import renderPostTwitter from "./renderPost/postTwitter.vue"
    import renderPostLinkedin from "./renderPost/postLinkedin.vue"
    import renderPostTiktok from "./renderPost/postTiktok.vue"
    import renderPostGoogle from "./renderPost/postGoogle.vue"
    import renderPostTelegram from "./renderPost/postTelegram.vue"
    import renderPostPinterest from "./renderPost/postPinterest.vue"
    import renderPostYoutube from "./renderPost/postYoutube.vue"
    import renderShortYoutube from "./renderPost/shortYoutube.vue"
    import renderPostThreads from "./renderPost/postThreads.vue"
    import renderPostBluesky from "./renderPost/postBluesky.vue"

    import { VueDraft } from '@mashupweb/draft-lib'
    import { deepMerge } from '@mashupweb/draft-lib/utils/objectUtils'

    export default {
        components: {
            renderPostInstagram,
            renderReelInstagram,
            renderPostFacebook,
            renderReelFacebook,
            renderPostTwitter,
            renderPostLinkedin,
            renderPostTiktok,
            renderPostGoogle,
            renderPostTelegram,
            renderPostPinterest,
            renderPostYoutube,
            renderShortYoutube,
            renderPostThreads,
            renderPostBluesky
        },
        props: {
            typeNetworkSelected: String,
            formData: Object,
            pages: Array,
            idsPagesStatusEdited: {
                type: Array,
                default: () => ([])
            },
            files: Object,
            positionFormOverlay: {
                type: String,
                default: 'left'
            },
            modes: {
                type: Array,
                default: () => ([])
            },
            draft: {
                type: VueDraft,
                default: false
            },
            formDataPatch: {
                type: Object,
                default: () => ({})
            },
        },
        methods: {
            clickPageInRenderPost(pageId) {
                this.$emit('clickPageInRenderPost', pageId)
            }
        },
        computed: {
            draftComputed() {
                if (this.formDataPatch && Object.keys(this.formDataPatch).length) {
                    const draftDump = this.draft.dump()
                    deepMerge(draftDump.saveAllFormData, this.formDataPatch)
                    return new VueDraft(draftDump)
                    //todo faire plutot  new VueDraft(draftDump).form.merge.run(page or network)
                }

                return this.draft
            },
            
            filesNetwork() {

                console.log('filesNetwork', this.draftComputed?.form?.medias.getByNetwork(this.typeNetworkSelected).toFiles(this.typeNetworkSelected), this.typeNetworkSelected)
                return this.draftComputed?.form?.medias.
                getByNetwork(this.typeNetworkSelected)
                .toFiles(this.typeNetworkSelected) ?? []

                // console.log("computed filesNetwork")
                // let formDataNetwork
                // if (this.formDataPatch.formDataNetwork && this.formDataPatch.formDataNetwork[this.typeNetworkSelected]) {
                //     formDataNetwork = JSON.parse(JSON.stringify(this.formData.formDataNetwork[this.typeNetworkSelected]))
                //     mergeUpdates(formDataNetwork, this.formDataPatch.formDataNetwork[this.typeNetworkSelected])
                // }else{
                //     formDataNetwork = this.formData.formDataNetwork[this.typeNetworkSelected]
                // }
                // console.log("computed filesNetwork",JSON.parse(JSON.stringify(this.formDataPatch.files || this.formData.files)))
                // //getFilesByNetwork(files, networkCheck, formDataNetworks, files)
                // const test = getFilesByNetwork(
                //     this.formDataPatch.files || this.formData.files, 
                //     [this.typeNetworkSelected], 
                //     {
                //         [this.typeNetworkSelected] : formDataNetwork
                //     },
                //     this.files
                // )[this.typeNetworkSelected]
                // console.log("computed filesNetwork test",test)
                //return test

            },

            pagesEdited() {
                if (this.draft.form.merge.target && this.draft.form.merge.target.id) {
                    return [{
                        ...this.draft.form.merge.target,
                        iconEdited: this.idsPagesStatusEdited.includes(this.draft.form.merge.target.id)
                    }]
                }

                return this.draft.pages
                .filter(page => page.network == this.typeNetworkSelected)
                .map(page => ({
                    ...page, 
                    iconEdited: this.idsPagesStatusEdited.includes(page.id)
                }))
            },

            textContentConverted() {
                //const textContent = this.draftComputed?.form?.textContent?.get() ?? ''
                const textContent = this.draftComputed?.form?.textContent?.render(this.typeNetworkSelected)
             
                const regex = /^(<br\s*\/?>|\\n|\s*)+$/i
                if (!textContent || regex.test(textContent)) return ''
                
                return textContent.replaceAll("\\n", '<br>')
            },

            commentsConverted() {

                //let comments = this.draftComputed?.form?.comments.dump()
                let comments = this.draftComputed.form.comments.allRendered(this.typeNetworkSelected)

                //si il est question que de saut de ligne
                const regex = /^(<br\s*\/?>|\\n|\s*)+$/i

                if (!comments || !comments.length || !comments.some(comment => !regex.test(comment))) return []

                return comments.reduce((acc, comment) => {
                    if (comment && !regex.test(comment)) acc.push(comment.replaceAll("\\n", '<br>'))
                    return acc
                },[])  
            },

            datePost() {
                return this.draftComputed?.form?.planifiedDate?.date?.getTime() ?? Date.now()
            },
            
            snippet() {
                return this.draftComputed?.form?.networks?.[this.typeNetworkSelected]?.snippet?.get() ?? undefined
            },

            mentions() {
                return this.draftComputed?.form?.mentions?.items ?? {}
            },

            place() {
                return this.draftComputed?.form?.networks?.[this.typeNetworkSelected]?.place ?? undefined
            },

            personsIdentified() {
                if (this.typeNetworkSelected !== 'instagram') return []
                return this.draftComputed?.form?.networks?.instagram?.personsIdentified ?? []
            },

            collaborators() {
                if (this.typeNetworkSelected !== 'instagram') return []
                return this.draftComputed?.form?.networks?.instagram?.collaborators ?? []
            },

            music() {
                if (!['instagram','tiktok'].includes(this.typeNetworkSelected)) return undefined
                return this.draftComputed?.form?.networks?.[this.typeNetworkSelected]?.music ?? undefined
            },

            products() {
                if (this.typeNetworkSelected !== 'instagram') return undefined
                return this.draftComputed?.form?.networks?.instagram?.products ?? undefined
            },

            ratio() {
                if (this.typeNetworkSelected !== 'instagram') return undefined
                return this.draftComputed?.form?.networks?.instagram?.ratio ?? undefined
            },

            survey() {

                if (this.typeNetworkSelected !== 'linkedin') return null

                if (this.draftComputed?.form?.networks?.linkedin?.survey?.active) {
                    return this.draftComputed.form.networks.linkedin.survey
                }
                return undefined
            },

        },

        watch: {
            'formData.files': {
                immediate: false,
                deep: false,
                handler(newValue, oldValue) {
                    console.log("this.formData.files changed",newValue)
                }
            }
        },
    }
</script>

<style lang="scss" scoped>

</style>
